import { Spinner } from "construct-ui";
import { messageComponent } from "../../../components/message/message.component";
import masterConfigurationModel from "../../../models/config-master.model";
import loginModel from "../../../models/login.model";
import ViewBase from "../../view-base.view";

export default function MasterViewDetailsView() {

    ViewBase.call(this);

    let inputDatModel = {
        pageIndex: 1, pageSize: 10, totalSize: 0, recordType: "", subsidiary: "", description: "", data: []
    };
    let countryID = 0;
    let isLoading = false;
    let isMsgOpen = false;
    let showMsg = "";
    let msgTitle = "";    

    let _loadMasterConfigurationList = (sub, recType, location) => {
        isLoading = true;
        masterConfigurationModel.getConfigMasterDetailsList(
            (result) => {
                isLoading = false;
                inputDatModel.data = result.data;
            },
            (error) => {
                isLoading = false;
                this.handleError(error);
            },
            sub,
            recType,
            location
        )
    }

    let _dialogClosed = () => {
        isMsgOpen = false;
    }

    return {
        oninit: (vnode) => {
            console.log("oninit");
            countryID = loginModel.credentials.country;
            _loadMasterConfigurationList(vnode.attrs.subsidiary, vnode.attrs.recordType, vnode.attrs.location);
        },
        onupdate: (vnode) => {
            if (countryID != loginModel.credentials.country) {
                countryID = loginModel.credentials.country;
            }
        },
        view: (vnode) => {
            return [
                m('.row',
                    m(Spinner, {
                        active: isLoading,
                        background: true,
                        fill: true,
                        size: 'xl',
                    }),
                    m('.col-12',
                        // Search section
                        m('.card.mb-3',
                            m('.card-body',

                                m('.row.g-4',
                                    m('.col-md-6',
                                        m('label.form-label', this.getText("LT00000576", "Subsidiary")),
                                        m('input[type=text][disabled][value="' + vnode.attrs.subsidiary + '"].form-control.form-control-bg')
                                    ),
                                    m('.col-md-6',
                                        m('label.form-label', this.getText("LT00000564", "Record Type")),
                                        m('input[type=text][disabled][value="' + vnode.attrs.recordType + '"].form-control.form-control-bg')
                                    ),
                                    m('.col-md-12',
                                        m('label.form-label', this.getText("LT00000012", "Description")),
                                        m('textarea[disabled][value="' + vnode.attrs.description + '"].form-control.form-control-bg')
                                    ),
                                )
                            )
                        ),

                        // Table section
                        m('.card',
                            m('.card-body',
                                m('.row',
                                    m(".col-12.p-0",
                                        m(".table-responsive",
                                            m("table.table",
                                                [
                                                    m("thead.thead-bggrey",
                                                        m("tr.align-middle",
                                                            [
                                                                m("th.center", { "scope": "col" }, this.getText("LT00000577", "Label")),
                                                                m("th.center", { "scope": "col" }, this.getText("LT00000512", "Sequence")),
                                                                m("th.center", { "scope": "col" }, this.getText("LT00000012", "Description")),
                                                                m("th.center", { "scope": "col" }, this.getText("LT00000013", "Data Type")),
                                                                m("th.center", { "scope": "col" }, this.getText("LT00000578", "In Use"))
                                                            ])
                                                    ),
                                                    m("tbody",
                                                        inputDatModel.data.length == 0 &&
                                                        m("tr", { "class": "align-middle" },
                                                            m("td", { "colspan": "9" }, this.getText("EM00000141", "No records found."))
                                                        ),
                                                        inputDatModel.data.map(gc =>
                                                            [
                                                                m("tr",
                                                                    [
                                                                        m("td.center", gc.label),
                                                                        m("td.right", gc.seq),
                                                                        m("td.center", m('span', gc.description)),
                                                                        m("td.center", gc.type),
                                                                        m("td.center", gc.isActive == 1 ? m('.badge.rounded-pill.green-bg-status', this.getText("LT00000023", "Yes")) : m('.badge.rounded-pill.grey-bg-status', this.getText("LT00000024", "No")))

                                                                    ])
                                                            ]),
                                                    )
                                                ])
                                        )
                                    )
                                )
                            )
                        )
                    ),

                    m(messageComponent, { isOpen: isMsgOpen, message: showMsg, title: msgTitle, onClosed: _dialogClosed })
                ),
                this.getBaseViews()
            ]
        }
    }
}
